// extracted by mini-css-extract-plugin
export default {"aside":"Sidebar_aside__W6loT","customMenu":"Sidebar_customMenu__9fOgz","profile":"Sidebar_profile__Hgt06","profileInfo":"Sidebar_profileInfo__lD0rx"};